import { gql } from '@apollo/client/core';

// Queries
export const GET_NOTIFICATIONS = gql`
  query GetNotifications {
    notifications {
      id
      type
      data
      read_at
      created_at
      updated_at
    }
  }
`;

export const SEARCH_NOTIFICATIONS_QUERY = gql`
  query SearchNotifications($first: Int!, $after: String, $unread_only: Boolean) {
    searchNotifications(first: $first, after: $after, unread_only: $unread_only) {
      edges {
        node {
          id
          type
          data
          read_at
          created_at
          updated_at
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const GET_UNREAD_NOTIFICATIONS = gql`
  query GetUnreadNotifications {
    notifications(unread_only: true) {
      id
      type
      data
      read_at
    }
  }
`;

export const GET_NOTIFICATION_STATS = gql`
  query GetNotificationStats {
    notificationStats {
      total
      unread
      read
    }
  }
`;

export const GET_NOTIFICATION_PREFERENCES = gql`
  query GetNotificationPreferences {
    notificationPreferences {
      id
      user_id
      notification_type
      email_enabled
      sms_enabled
      whatsapp_enabled
      push_enabled
      in_app_enabled
    }
  }
`;

// Mutations
export const MARK_NOTIFICATION_AS_READ = gql`
  mutation MarkNotificationAsRead($id: ID!) {
    markNotificationAsRead(id: $id) {
      success
      message
      code
      reason
    }
  }
`;

export const MARK_ALL_NOTIFICATIONS_AS_READ = gql`
  mutation MarkAllNotificationsAsRead {
    markAllNotificationsAsRead {
      success
      message
      code
      reason
      data
    }
  }
`;

export const DELETE_NOTIFICATION = gql`
  mutation DeleteNotification($id: ID!) {
    deleteNotification(id: $id) {
      success
      message
      code
      reason
    }
  }
`;

export const UPDATE_NOTIFICATION_PREFERENCES = gql`
  mutation UpdateNotificationPreferences($input: UpdateNotificationPreferencesInput!) {
    updateNotificationPreferences(input: $input) {
      success
      message
      code
      reason
    }
  }
`;

// Subscription for real-time notifications
export const NOTIFICATION_SUBSCRIPTION = gql`
  subscription OnNotificationReceived {
    notificationReceived {
      id
      type
      data
    }
  }
`; 